import { t } from "i18next";
import { MAX_VIDEO_FILE_BYTES, VIDEO_FILE_ACCEPT } from "@components/PostVideoButton/PostVideoModal/constants";

export { MAX_VIDEO_FILE_BYTES, VIDEO_FILE_ACCEPT };

const ALLOWED_EXTENSIONS = [".mp4", ".mov"];

const getFileExtension = (fileName: string) => {
  const index = fileName.lastIndexOf(".");
  return index >= 0 ? fileName.slice(index).toLowerCase() : "";
};

export const isAllowedReferenceVideoFile = (file: File) => {
  const extension = getFileExtension(file.name);
  if (ALLOWED_EXTENSIONS.includes(extension)) return true;
  return VIDEO_FILE_ACCEPT.some((item) => item.startsWith("video/") && file.type === item);
};

export const validateReferenceVideoBeforeUpload = (file: File) => {
  if (!isAllowedReferenceVideoFile(file)) {
    return t("File too large or format unsupported,please try again");
  }
  if (file.size > MAX_VIDEO_FILE_BYTES) {
    return t("File too large or format unsupported,please try again");
  }
  return true;
};
